var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 58,
    stroke: "#6EE1DC",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 9,
    rx: 4.5,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 36.8125 42.6758)",
    fill: "#6EE1DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 9,
    rx: 4.5,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 43.1758 83.6875)",
    fill: "#6EE1DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.c578e30d4cb415490e1b0945e26ec49e.svg";
export { ForwardRef as ReactComponent };